import { BDropdownItemButton } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBDropdownItemButton when migrating. */
export const EgBDropdownItemButton = createEgBootstrapProxy(
  "EgBDropdownItemButton",
  BDropdownItemButton
);
